import { NameInput } from '@entities/SpaceObject/name/input';
import { OrbitInput } from '@entities/SpaceObject/orbit/input';
import { EntityFilterInput } from '@entities/Sst/entity/filterInput';
import { SstFilterValues } from '@features/ssts/hooks/useSstUrlState';
import { TableFilterContainer, TableFilterHeader, TableFilterTitle } from '@features/ui-atoms/components/TableV2/Table';
import Button, { ButtonVariants } from '@features/ui-form/components/Button';
import FieldWrapper from '@features/ui-form/components/FieldWrapper';
import Divider from '@mui/joy/Divider';
import { CategoryInput } from '@root/src/entities/SpaceObject/category/input';
import { CosparIdInput } from '@root/src/entities/SpaceObject/cosparId/input';
import { NoradIdInput } from '@root/src/entities/SpaceObject/noradId/input';
import { SstTypeInput } from '@root/src/entities/Sst/sstType/input';
import { useTranslation } from 'next-i18next';

interface SstForumFiltersProps {
  filters: SstFilterValues;
  hasActiveFilters: boolean;
  handleFilterChange: (field: keyof SstFilterValues, value: string | string[]) => void;
  resetFilters: () => void;
}

export const SstForumFilters: React.FC<SstForumFiltersProps> = ({
  filters: {
    'spaceObject.name': name,
    entity,
    'spaceObject.cosparId': cosparId,
    'spaceObject.noradId': noradId,
    'spaceObject.orbit': orbit,
    'spaceObject.category': category,
    sstType,
  },
  hasActiveFilters,
  handleFilterChange,
  resetFilters,
}) => {
  const { t } = useTranslation('common');

  return (
    <div style={{ marginTop: '22px' }}>
      <TableFilterHeader>
        <TableFilterTitle>{t('label.filters')}</TableFilterTitle>
        {hasActiveFilters && (
          <Button label={t('action.clearAllFilters')} onClick={resetFilters} variant={ButtonVariants.TEXT_PRIMARY} />
        )}
      </TableFilterHeader>
      <TableFilterContainer>
        <NameInput
          value={name}
          onChange={e => handleFilterChange('spaceObject.name', e.target.value)}
          hideError
          withSearchIcon
        />
        <CosparIdInput
          value={cosparId}
          onChange={e => handleFilterChange('spaceObject.cosparId', e.target.value)}
          hideError
          withSearchIcon
        />
        <NoradIdInput
          value={noradId}
          onChange={e => handleFilterChange('spaceObject.noradId', e.target.value)}
          hideError
          withSearchIcon
        />
        <SstTypeInput value={sstType} onChange={e => handleFilterChange('sstType', e.target.value)} hideError />
        <Divider />
        <FieldWrapper name="category" label={t('spaceObject.category')} error="">
          <CategoryInput value={category} onChange={value => handleFilterChange('spaceObject.category', value)} />
        </FieldWrapper>
        {/** ADD LAUNCHING STATE */}
        <EntityFilterInput value={entity} onChange={values => handleFilterChange('entity', values)} hideError />
        <FieldWrapper name="orbit" label={t('spaceObject.orbit')} error="">
          <OrbitInput value={orbit} onChange={value => handleFilterChange('spaceObject.orbit', value)} />
        </FieldWrapper>
      </TableFilterContainer>
    </div>
  );
};
